export default __webpack_public_path__ + "static/media/1.296d40b0.png";